import React from "react";
import { IconProps } from "./types";

function IconRatings(props: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="32"
      height="32"
      viewBox="0 0 32 32"
      {...props}
    >
      <defs>
        <clipPath id="a">
          <rect width="32" height="32" fill="none" />
        </clipPath>
      </defs>
      <g clipPath="url(#a)">
        <path
          d="M7,0H25a7,7,0,0,1,7,7V25a7,7,0,0,1-7,7H7a7,7,0,0,1-7-7V7A7,7,0,0,1,7,0"
          fill="#ffbd22"
        />
        <path
          d="M22.207,27.684H9.793a5.483,5.483,0,0,1-5.477-5.477V9.793A5.483,5.483,0,0,1,9.793,4.316H22.207a5.483,5.483,0,0,1,5.477,5.477V22.207a5.483,5.483,0,0,1-5.477,5.477M9.793,6.141A3.656,3.656,0,0,0,6.141,9.793V22.207a3.656,3.656,0,0,0,3.652,3.652H22.207a3.656,3.656,0,0,0,3.652-3.652V9.793a3.656,3.656,0,0,0-3.652-3.652Zm9.423,17.207a2.44,2.44,0,0,1-1.126-.277l-1.809-.942a.613.613,0,0,0-.562,0l-1.809.942a2.418,2.418,0,0,1-2.558-.194A2.388,2.388,0,0,1,10.4,20.53l.346-1.993a.573.573,0,0,0-.169-.51L9.114,16.615a2.408,2.408,0,0,1,1.34-4.108l2.023-.291a.6.6,0,0,0,.449-.321l.9-1.814a2.435,2.435,0,0,1,4.34,0l.9,1.814a.594.594,0,0,0,.449.321l2.023.291a2.408,2.408,0,0,1,1.34,4.108l-1.463,1.412a.573.573,0,0,0-.169.51L21.6,20.53a2.388,2.388,0,0,1-.952,2.347,2.424,2.424,0,0,1-1.432.471M16,20.235a2.429,2.429,0,0,1,1.123.275l1.809.941a.592.592,0,0,0,.639-.048.563.563,0,0,0,.23-.561l-.346-1.994a2.4,2.4,0,0,1,.7-2.135L21.618,15.3a.559.559,0,0,0,.15-.587.577.577,0,0,0-.482-.4l-2.022-.291a2.419,2.419,0,0,1-1.823-1.313L16.536,10.9a.6.6,0,0,0-1.072,0l-.9,1.814a2.417,2.417,0,0,1-1.822,1.313l-2.023.291a.574.574,0,0,0-.481.4.556.556,0,0,0,.149.587l1.463,1.412a2.4,2.4,0,0,1,.7,2.135L12.2,20.842a.563.563,0,0,0,.23.561.593.593,0,0,0,.639.048l1.809-.941A2.429,2.429,0,0,1,16,20.235"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default IconRatings;
